export const close_repair_form = {
  body_label: "Closing note (optional)",
  body_placeholder: "Optional note posted when closing…",
};
